import styled from '@emotion/styled';
import { withTheme, SvyButton as Button } from '@innovorder/savory';

export const SvyButton = styled(withTheme(Button))``;
